var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.611 35.945 28.535 26l-9.924-9.945L21.666 13l13 13-13 13-3.055-3.055Z",
    fill: "#323232"
  })));
};
export { SvgRightArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1MiA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjYxMTMgMzUuOTQ1TDI4LjUzNDcgMjZMMTguNjExMyAxNi4wNTVMMjEuNjY2MyAxM0wzNC42NjYzIDI2TDIxLjY2NjMgMzlMMTguNjExMyAzNS45NDVaIiBmaWxsPSIjMzIzMjMyIi8+Cjwvc3ZnPgo=";